
interface Props {
    note: any;
}

const LinkedNoteResolver = ({ note }: Props) => {
    console.log('LinkedNoteResolver', note);

    return <div>LinkedNoteResolver</div>;
};

export default LinkedNoteResolver;
